import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { QuaiManager_DropDownCaret } from '@app/styles';
import { CriticalityLabelMap, criticalityValues } from '@app/dp-shared';
export const Props_CriticalityDropDown = {
    adapter: () => SimpleListAdapter([...criticalityValues], criticality => _jsx(_Fragment, { children: CriticalityLabelMap[criticality.item] })),
    placeholder: 'Pick Criticality',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_Criticality = TS_DropDown.prepare(Props_CriticalityDropDown);
//# sourceMappingURL=ui-components.js.map